import { useModals } from '@frontend/modal';
import { useLocation, useNavigate } from 'react-router-dom';

import { useAppDispatch } from '../../../redux/store';

export const useAttributes = () => {
    const dispatch = useAppDispatch();
    const { openModal, closeModal } = useModals();
    const navigate = useNavigate();
    const location = useLocation();
    const listId = 'attributes-list';
    const createAttributeModalId = 'create-attribute-modal';

    return {
        dispatch,
        listId,
        createAttributeModalId,
        openModal,
        closeModal,
        navigate,
        location
    };
};
